<div>
  <form [formGroup]="contribution" class="pb-4 row-container w-100">
    <mat-form-field class="w-25" appearance="outline">
      <mat-label i18n="vaki-support-form | Currency label @@currencyLabel"
        >Moneda
      </mat-label>
      <mat-select formControlName="currency">
        <mat-option *ngFor="let currency of currencies" [value]="currency">
          {{ currency }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="ml-4 w-75" appearance="outline">
      <mat-label
        class="mat-subtitle-1 remove-margin"
        i18n="vaki-support-form |Value label @@valueLabel"
      >
        ¿Cuánto quieres aportar?
      </mat-label>
      <div
        matPrefix
        class="mat-subtitle-1 p-2 text-primary align-center remove-margin"
      >
        {{ 0 | currencyFormat: contribution.value.currency:true }}
      </div>
      <input
        placeholder="0"
        matInput
        input="number"
        vakiMatInputNumber
        formControlName="value"
        data-cy="vakiSupportFormValue"
      />
      <mat-hint
        class="text-warn"
        *ngIf="contribution?.get('value')?.errors?.['min'] as minError"
        i18n="view | Contribution hint @@contributionMinimumHint"
      >
        Aporte mínimo:
        {{
          minError.min | number | currencyFormat: contribution.value.currency
        }}
      </mat-hint>
    </mat-form-field>
  </form>
  <a
    [disabled]="
      contribution.invalid ||
      (vaki?.info?.close_date | isVakiClosed) ||
      !available
    "
    [routerLink]="['/checkout/', vaki?.key]"
    [queryParams]="contribution.value"
    class="txt-uppercase w-100 text-white"
    color="primary"
    mat-flat-button
    i18n="vaki-support-form |Support button @@vakiSupportButton"
    [vakiLogAnalytics]="{
      event: ga4ClickEvents.CLICK_VAKI_SUPPORT,
      paramsInputs: {
        vaki: vaki,
        payment: {
          currency: contribution.value?.currency,
          value: contribution.value?.value
        }
      }
    }"
    (click)="
      algoliaService.vakiConverted(
        authService.uid(),
        exploreStateService.queryId(),
        vaki?.key ?? ''
      )
    "
    data-cy="vakiSupportFormButton"
  >
    APORTAR
  </a>
</div>
